import axios from "axios";
import {MASTER_ITEM_DETAIL_ADJUSTMENT_LIST_URL} from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST = 'FETCH_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST'
export const RECEIVE_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST = 'RECEIVE_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST'
export const FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST = 'FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST'
export const ADD_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT = 'ADD_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT'

export function fetchStckMasterItemDetailAdjustment(_id_master_item_detail){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST});
        axios({
            method: 'post',
            url: MASTER_ITEM_DETAIL_ADJUSTMENT_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_master_item_detail: _id_master_item_detail
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function addMasterItemDetailAdjustment(data){
    return (dispatch, getState) => {
        try{
            dispatch( {
                type: ADD_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT,
                payload: data
            })
        }
        catch(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_MASTER_ITEM_DETAIL_ADJUSTMENT_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        }
    }
}